import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {Document} from "../_models/document";

const pathApi = 'Documento';

@Injectable({
  providedIn: 'root',
})
export class DocumentoService {

  cache$: Observable<Document[]>;

  constructor(private http: HttpClient) {
  }

  public getDocument(codigoDocumento: string): Observable<Document[]> {
    this.cache$ = this.http.post<Document[]>(
      `${ environment.URL_API_CMS }/${ pathApi }`,
      [codigoDocumento],
    ).pipe(shareReplay(1));

    return this.cache$;
  }
}
